import React from "react";
import axios from "axios";
import "../auth.css";
import "../card.css";
import "../sidemenu.css";
import "../just.css";
import { reactLocalStorage } from "reactjs-localstorage";
import i18n from "../i18n";
import { Button, Icon,Modal } from "semantic-ui-react";
import { toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";
//import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow, MapWithAMarker, Data} from "react-google-maps";
import { Circle } from "react-google-maps";
import {
  LoadScript,
  GoogleMap,
  DrawingManager,
  Polygon,
  Polyline,
  Marker,
  
  InfoWindow,
  MapWithAMarker,
} from "@react-google-maps/api";

import Geocode from "react-geocode";
import { API_BASE_URL } from "../utils/endpoints";

Geocode.setApiKey("AIzaSyDQeFQZw5wt1b3at0-cXKnYiZSg0MfQFdM");
const libraries = ["drawing", "places"];

const googleKey = {
  key: "AIzaSyDQeFQZw5wt1b3at0-cXKnYiZSg0MfQFdM",
  libraries: ["drawing", "places"].join(","),
};

const options = {
  drawingControl: true,
  drawingControlOptions: {
    drawingModes: ["circle"],
  },

  circleOptions: {
    fillColor: `#2196F3`,
    strokeColor: `#2196F3`,
    fillOpacity: 0.5,
    strokeWeight: 2,
    clickable: true,
    editable: true,
    draggable: true,
    zIndex: 1,
    radius: 2000,
  },
};

var selectedShape;

const circleRef = null;

class AddArea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      radius: 0,
      allEdits: [],
      map: null,
      path: [],
      isDrawing: false,
      shapes: [],
      drawingModes: ["polygon", "circle", "polyline"],
      address: "",
      city: "",
      area: "",
      state: "",
      zoom: 14,
      height: 400,
      mapPosition: {
        lat: "0",
        lng: "0",
      },
      markerPosition: {
        lat: "0",
        lng: "0",
      },
      circleData: [],
      pathCircle: [],
      Object: {},
    };

    this.handleOverlayComplete = this.handleOverlayComplete.bind(this);
    this.deleteShapes = this.deleteShapes.bind(this);
    this.clearSelection = this.clearSelection.bind(this);
    this.setSelection = this.setSelection.bind(this);
    this.deletSelectedSahape = this.deletSelectedSahape.bind(this);

   // this.shouldComponentUpdateshouldComponentUpdate = this.shouldComponentUpdateshouldComponentUpdate.bind(this);
  
    this.getvalues = this.getvalues.bind(this);
  }

  getvalues(e) {
    const radius = this.map.getRadius();
    const center = this.map.getCenter();
    this.setState({ radius: radius });
    this.setState({
      "mapPosition.lat": center.lat(),
      "mapPosition.lng": center.lng(),
    });
    console.log("raduis", this.setState.radius);
  }

  handleOverlayComplete(e) {
    const newshape = e.overlay;
    newshape.type = e.type;

    window.google.maps.event.addListener(newshape, "click", () => {
      this.setSelection(newshape);
    });
    this.setSelection(newshape);

    this.state.shapes.push(newshape);
  }

  clearSelection() {
    if (selectedShape) {
      selectedShape.setEditable(false);
      selectedShape = null;
    }
  }

  setSelection(shape) {
    this.clearSelection();
    selectedShape = shape;
    shape.setEditable(true);
    //selectColor(shape.get('fillColor') || shape.get('strokeColor'));
  }

  deletSelectedSahape() {
    if (selectedShape) {
      var index = this.state.circleData.indexOf(selectedShape);
      console.log(index);
      this.state.circleData.splice(index, 1);
      console.log("allahapes after removing one", this.state.circleData);
      selectedShape.setMap(null);
    }
  }

  deleteShapes() {
    var array = [];
    this.setState({ circleData: array });
    this.state.shapes.forEach((shape) => shape.setMap(null));
    console.log(this.state.circleData);
  }

  noDraw = () => {
    this.setState(function set(prevState) {
      return Object.assign({}, prevState, {
        drawingMode: "maker",
      });
    });
  };

  onCircleComplete = function onCircleComplete(circle) {
    document.getElementById("button").disabled = false;
    console.log("circle", circle);
    const circlelat = circle.getCenter().lat();
    const circleLang = circle.getCenter().lng();
    const radius = circle.radius;
    const circlesArray = [];

    var Object = { long: circleLang, lat: circlelat, radius: radius };
    this.setState({ Object: Object });
    console.log("Object", Object);
    console.log(circleLang, circlelat, radius);
    if (this.state.circleData.length < 4) {
      // this.state.circleData.push(Object)
    } else {
      console.log("over");
    }

    console.log(this.state.circleData);

    this.noDraw();

    window.google.maps.event.addListener(circle, "radius_changed", (event) => {
      console.log("circle radius changed", circle.getRadius());
      var radius = circle.getRadius();
      console.log(radius);
      var object = { long: circleLang, lat: circlelat, radius: radius };
      console.log("Object", object);
      this.setState({ Object: object });
    });

    window.google.maps.event.addListener(circle, "center_changed", (event) => {
      console.log("circle center changed", circle.getCenter().toUrlValue(15));
      var circleLang = circle.getCenter().lng();
      var circlelat = circle.getCenter().lat();
      var object = { long: circleLang, lat: circlelat, radius: radius };
      this.setState({ Object: object });
    });
  };

  Save = () => {
    var array = [];
    for (var key in this.state.Object) {
      array.push(key);
    }
    if (array.length > 0) {
      var Object = this.state.Object;
      this.state.circleData.push(Object);
    }
    var ob = {};
    this.setState({ Object: ob });
    console.log("save", this.state.circleData);
    // document.querySelector('.button').sty
    document.getElementById("button").disabled = true;
  };

  circleSubmit = () => {
    if (this.state.circleData.length > 0) {
      var token = reactLocalStorage.get("accessToken");
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      var data = { area: this.state.circleData, area_name: "test" };
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/general/createPredefinedArea";
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/general/createPredefinedArea";
      }
      var headers = {
        token: token,
      };
      axios
        .post(apiBaseUrl, data, { headers: headers })
        .then(function(response) {
          if (response.status === 200) {
            if (response.data.result != undefined) {
              if (response.data.status === "success") {
                console.log(response.data.status);
              } else {
                toast({
                  type: "warning",
                  title: i18n.t("warning.label"),
                  description: response.data.status,
                  animation: "bounce",
                  time: 5000,
                });
              }
            }
          } else if (response.status === 204) {
            console.log("Something wrong");
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("Something_wrong.label"),
              animation: "bounce",
              time: 5000,
            });
          } else {
            console.log("Something wrong");
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("Something_wrong.label"),
              animation: "bounce",
              time: 5000,
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        });
    }
  };

  componentDidMount() {
    document.getElementById("button").disabled = true;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.setState(
          {
            mapPosition: {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            },
            markerPosition: {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            },
          },
          () => {
            Geocode.fromLatLng(
              position.coords.latitude,
              position.coords.longitude
            ).then((response) => {
              console.log("response", response);
             
            });
          }
        );
      });
    }
  }

  onInfoWindowClose = (event) => {};

  render() {
    return (
    
     
  
      
      <>
        <div>
          <Button onClick={this.deletSelectedSahape} color="red">
            Delete selected
          </Button>

          

          <Button
            className="button"
            id="button"
            onClick={this.Save}
            color="red"
          >
            SAVE
          </Button>

        </div>
        <LoadScript
          googleMapsApiKey={googleKey.key}
          libraries={libraries}
          id="script-loader"
          language="en"
        >
          <GoogleMap
            center={{
              lat: this.state.mapPosition.lat,
              lng: this.state.mapPosition.lng,
            }}
            mapContainerClassName={"map-style"}
            zoom={10}
            onClick={this.clearSelection}
            radius={this.state.radius}
            onRadiusChanged={this.getvalues}
          >
            <div className="deleteShaps">
              <Button icon onClick={this.deleteShapes}>
                <Icon name="trash alternate outline" size="large" />
              </Button>
            </div>
            <div className="UploadShaps">
              <Button icon onClick={this.circleSubmit}>
                <Icon name="upload" size="large" />
              </Button>
            </div>

            {this.state.path.length === 0 ? (
              <DrawingManager
                drawingMode={this.state.drawingMode}
                options={options}
              
                onCircleComplete={this.onCircleComplete.bind(this)}
                editable
                draggable
                onMouseUp={this.onEdit}
                onDragEnd={this.onEdit}
                onOverlayComplete={this.handleOverlayComplete}
              />
            ) : (
              <Circle
                options={{
                  fillOpacity: 0.45,
                  strokeWeight: 0,
                }}
                onClick={() => {
                  this.onSelect();
                }}
                onRightClick={() => {
                  this.onSelect();
                }}
                onRadiusChanged={console.log("me")}
                editable={false}
                visible={true}
                draggable={false}
                onMouseUp={this.onEdit}
                onLoad={this.onLoad}
              />
            )}
            {this.state.path.map((pos, key) => {
              console.log(pos);
              return <Marker key={key} label={"" + key} position={pos} />;
            })}
          </GoogleMap>
        </LoadScript>

      </>
   
    
    );
  }
}
export default AddArea;



